import { render, staticRenderFns } from "./FletrixTextarea.vue?vue&type=template&id=19b559be&scoped=true&"
import script from "./FletrixTextarea.vue?vue&type=script&lang=js&"
export * from "./FletrixTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FletrixTextarea.vue?vue&type=style&index=0&id=19b559be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b559be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
